import { createFileRoute } from "@tanstack/react-router";
import agendaOgImage from "@/assets/OP2P-CRM-e-Agentes-de-IA-agenda-og.jpg.asset.json";
import { buildHead } from "@/lib/seo-head";
import Agenda from "@/pages/Agenda";

export const Route = createFileRoute("/agenda/")({
  head: () => buildHead({
    title: "Agende uma conversa com a OP2P — CRM e Agentes de IA",
    description: "Escolha o melhor dia e horário para falar com o time da OP2P. Reunião online, link gerado automaticamente.",
    path: "/agenda",
    image: `https://op2p.ai${agendaOgImage.url}`,
  }),
  component: Agenda,
});
